<template>
    <v-dialog v-model="model" max-width="600px" persistent>
        <v-card>
            <div class="pl-4 pr-3 py-3" :style="{backgroundColor:item.color}">
                <div class="d-flex align-center justify-space-between">
                    <div class="font-weight-medium" :style="{color:item.colorText}">DETAIL</div> 
                    
                    <div>
                        <v-btn small text fab @click="$emit('accept')" class="my-0">
                            <v-icon small :color="item.colorText">fa-times</v-icon> 
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-divider></v-divider>

            <v-card-text class="pb-8 pt-6">
                <div class="px-4 grey--text text--darken-3 d-flex align-center justify-center flex-column" style="line-height:1.2">
                    <div class="white--text title">
                        <span style="border-radius:50%; width:32px; height:32px; display: inline-block; text-align:center" :style="{backgroundColor:item.color}">
                            {{item.num}}
                        </span>
                    </div>
                    <div class="title font-weight-regular mt-2">{{item.title}}</div>
                </div>
                <div class="px-4 grey--text text--darken-2 body-1 text-center mt-2" style="line-height:1.3" v-if="item.description">
                    {{item.description}}
                </div>
            </v-card-text>

            <div class="d-flex justify-end align-center pa-4">
                <v-btn depressed large :color="item.color" @click="$emit('accept')" :style="{color:item.colorText}">Close</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['model', 'item'],
    mounted() {
        console.log(this.item)
    }
}
</script>

